import { FunctionComponent } from 'react';
import classnames from 'classnames';

import Title from '../Title';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({ descriptions, title }) => {
    const isEvenNumber = descriptions?.length % 2 == 0;

    return (
        <StyledComponent className="public-page-company-site-section-company-block-aboutus">
            <Title title={title} />
            <div className={classnames('boxes', {
                'is-even-number': Boolean(isEvenNumber),
            })}
            >
                { Array.isArray(descriptions) && descriptions
                    .map(({ id, description: descContent }) => (
                        <div
                            key={id}
                            className="box"
                        >
                            <header className="box-header">
                                <p>{descContent.title}</p>
                            </header>
                            <p className="box-content">
                                {descContent.description}
                            </p>
                        </div>
                    ))}
            </div>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;
